export const profileStatsState = {
    defaultState: {
        profileStatsChanges: {},
    },
    actions: {
        changeProfileStats: (change, state) => ({
            ...state,
            profileStatsChanges: {
                ...state.profileStatsChanges,
                [change.userId]: {
                    ...(state.profileStatsChanges?.[change.userId] || {}),
                    ...change,
                    followersDelta: (state.profileStatsChanges?.[change.userId]?.followersDelta || 0) + (change.followersDelta || 0),
                    followingDelta: (state.profileStatsChanges?.[change.userId]?.followingDelta || 0) + (change.followingDelta || 0),
                    version: (state.profileStatsChanges?.[change.userId]?.version || 0) + 1,
                },
            },
        }),
    },
}
